"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedValueAvatar = getSelectedValueAvatar;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _react = _interopRequireDefault(require("react"));
var _avatar = require("../../avatar");
var _types = require("../types");
const baseAvatarProps = {
  tabIndex: -1,
  role: "presentation",
  "aria-hidden": true
};
const groupAvatarProps = {
  ...baseAvatarProps,
  color: {
    backgroundColor: (0, _designTokensReact.color)("color--background--info--weaker"),
    textColor: (0, _designTokensReact.color)("color--text--neutral--strong")
  },
  content: /*#__PURE__*/_react.default.createElement(_lodestarIcons.ShareIcon, {
    size: "xxSmall"
  })
};
const avatarTheme = (0, _sdsThemeInternal.themed)({
  size: {
    "lodestar-light": "xSmall",
    "ursa-light": "xxSmall"
  }
});
function getSelectedValueAvatar(option, themeMode) {
  if (!option) {
    return undefined;
  } else if ((0, _types.isGroupContact)(option)) {
    return /*#__PURE__*/_react.default.createElement(_avatar.Avatar, (0, _extends2.default)({}, groupAvatarProps, {
      size: avatarTheme.size(themeMode)
    }));
  } else {
    return /*#__PURE__*/_react.default.createElement(_avatar.Avatar, (0, _extends2.default)({
      src: option.profileImageUrl,
      initials: option.initials,
      email: option.emailAddress || option.name || option.id,
      size: avatarTheme.size(themeMode)
    }, baseAvatarProps));
  }
}
//# sourceMappingURL=getSelectedValueAvatar.js.map